/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const AI_ML = lazyLoad(
  () => import('./index'),
  module => {
    return module.AI_ML;
  },
);
